import * as Geocoding from '../../../output/Restaumatic.Services.Geocoding.Default/index.js'

const componentForm = {
  street_number: 'short_name',
  premise: 'long_name',
  route: 'long_name',
  locality: 'long_name',
  neighborhood: 'long_name',
  administrative_area_level_1: 'short_name',
  country: 'long_name',
  postal_code: 'short_name'
}

const testService = {
  getAddresses: (query, callback) => {
    setTimeout( () =>
      callback([
        { description: "Jasnorzewskiej 5, Warszawa", place_id: 10 },
        { description: "Wolnosci 345, Zabrze", place_id: 11 },
      ])
    , 1)
  },
  getAddressDetails: (placeId, callback) => {
    callback({
      street: "Jasnorzewskiej 5",
      streetNumber: 5,
      city: "Warszawa",
      postCode: "01863",
      latitude: 51.0,
      longitude: 24.0,
    })
  }
}


const buildAddress = (address, component) => {
  const addressType = component.types[0]
  if (componentForm[addressType]) {
    address[addressType] = component[componentForm[addressType]]
  }
  return address
}

const getCoordinates = (place) => {
  const l = place.geometry.location
  if (typeof l.lat == 'function')
    return {latitude: l.lat(), longitude: l.lng() }
  else {
    return {latitude: l.latitude, longitude: l.longitude }
  }
}

const placeToJSON = (place) => {
  if (!place.geometry) {
    return {}
  } else {
    return place.address_components.reduce(buildAddress, getCoordinates(place))
  }
}

const toAddress = (place) => {
  const address = placeToJSON(place)
  return {
    street: address.route,
    streetNumber: address.street_number,
    premise: address.premise,
    city: address.locality,
    postCode: address.postal_code,
    latitude: address.latitude,
    longitude: address.longitude,
    addressLine: place.formatted_address,
    placeTypes: place.types,
    country: address.country
  }
}

const autoCompleteRequest = (query) => ({ input: query, types: ['geocode'] })

const placeReferenceRequest = (reference) => ({ reference: reference })

const placeDetailsRequest = (placeId) => ({ placeId: placeId })


const getPlacesService = () => {
  const el = document.getElementById("places_service_attribution")
  if (!el) {
    console.warn("Please define a div with id=places_service_attribution!")
  }
  return new google.maps.places.PlacesService(el)
}

var autoCompleteService = null

const toHiggsCountry = (country) => country.toUpperCase()

const toStreetAddress = (addressObj) => ({ street: addressObj.street, streetNumber: addressObj.streetNumber, city: addressObj.city })

const geoCode = (addressObj, callback) => {
  const geocodeData =
    { streetAddress: toStreetAddress(addressObj)
    , country: toHiggsCountry(addressObj.country)
    }
  // Note: Address is loaded on document ready, so the value should be available
  // Remove after tests are finished
  const restaurantId = window.Skubacz.configuration.id;
  Geocoding.geocodeJS(
    { params: geocodeData
    , onError: () => ( callback({}, 'ERROR') )
    , restaurantId: restaurantId
    , onSuccess: (out) => ( () => (callback(out, 'OK')) )
    })();
}

export default {
  geoCode: (address, callback) => {
    geoCode(address, (response, status) => callback(response, status))
  },

  getAddresses: (query, callback) => {
    if (autoCompleteService == null) {
      autoCompleteService = new google.maps.places.AutocompleteService()
    }
    autoCompleteService.getPlacePredictions(autoCompleteRequest(query), callback)
  },
  getAddressDetails:  (place_id, callback) => {
    getPlacesService().getDetails(placeDetailsRequest(place_id), ( place, status) => {
      if (status === 'OK') {
        callback(toAddress(place))
      } else {
        callback(status)
        console.log("PlacesService#getAddressDetails(#{place_id}) returned #{status}")
      }
    })
  },
  getAddressDetailsByReference: (reference, callback) => {
    getPlacesService().getDetails(placeReferenceRequest(reference), (place, status) => {
      if (status === 'OK') {
        callback( toAddress(place))
      } else {
        callback(status)
        console.log("PlacesService#getAddressDetailsByReference(#{reference}) returned #{status}")
      }
    })
  }
}
